import { render, staticRenderFns } from "./EV3JsonEditor.vue?vue&type=template&id=0efc0626&scoped=true"
import script from "./EV3JsonEditor.vue?vue&type=script&lang=js"
export * from "./EV3JsonEditor.vue?vue&type=script&lang=js"
import style0 from "./EV3JsonEditor.vue?vue&type=style&index=0&id=0efc0626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efc0626",
  null
  
)

export default component.exports